export default function () {
    this.loadReservation()
    this.loadAvailableStatuses()
}
